import ErrorBoundary from '@/components/ErrorBoundary';
import { LabradorComponent } from '@/types/component';
import { renderContentComponent } from 'modules/dynamic-components';
import { Fragment } from 'react';

const HantLabradorBodytext: LabradorComponent = ({ type, data, meta, descendants }) => {
  const children = descendants.map((child, index) => {
    if (child.type === 'heading') {
      child.meta.className = '-mb-2 sm:-mb-4';
    }
    return <Fragment key={index}>{renderContentComponent(child)}</Fragment>;
  });

  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default HantLabradorBodytext;
